module.exports = __webpack_public_path__ + "static/media/app_zh.c970fc12.png";